import React, { ComponentType, useEffect, useState } from 'react';
import { ICell } from 'models/interfaces/spreadsheet-types/core-types';

interface WithCellEventListenerProps {
  cell: ICell;
  className?: string;
  [key: string]: any;
}

interface EnhancedComponentProps extends WithCellEventListenerProps {
  value?: any;
  backgroundColor?: string;
}

// eslint-disable-next-line react/display-name
const withCellEventListener = <P extends WithCellEventListenerProps>(
  WrappedComponent: ComponentType<P & EnhancedComponentProps>
) => function WithCellEventListener(props: P) {
    const { cell, className } = props;
    const fullKey = cell.getFullKey ? cell.getFullKey() : undefined;
    const [value, setValue] = useState<any>();
    const [cellClassName, setCellClassName] = useState<string | undefined>(className);
    const [cellBackgroundColor, setCellBackgroundColor] = useState<string | undefined>();

    useEffect(() => {
      setCellClassName(className);
    }, [className]);

    useEffect(() => {
      const getValueHandler = () => {
        setValue(cell.value);
        const tmpClassName = className ?? '';
        const tmpCellClassName = cell.className ?? '';
        const cellClassesSet = new Set([...tmpCellClassName.split(' '), ...tmpClassName.split(' ')]);
        setCellClassName(Array.from(cellClassesSet).join(' '));
        setCellBackgroundColor(cell.backgroundColor);
      };

      if (fullKey) {
        document.addEventListener(fullKey, getValueHandler);
        return () => document.removeEventListener(fullKey, getValueHandler);
      }
      return undefined;
    }, [cell, fullKey, cell.value, cell.colSpan, className]);

    const enhancedProps = {
      ...props,
      value,
      className: cellClassName,
      backgroundColor: cellBackgroundColor,
    } as P & EnhancedComponentProps;

    return React.createElement(WrappedComponent, enhancedProps);
  };

export default withCellEventListener;